export default __webpack_public_path__ + "static/media/arrow-right.707a0ab4.svg";